var _ellipse, _path, _path2, _path3, _path4, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1595,
    cy: 47.9368,
    rx: 47.7807,
    ry: 47.7807,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9403 47.9368C95.9403 39.4956 93.704 31.2051 89.4591 23.9089C85.2142 16.6127 79.1122 10.5713 71.7739 6.39946C64.4357 2.22762 56.1232 0.0742758 47.6825 0.158555C39.2417 0.242835 30.9739 2.56173 23.7204 6.87927L48.1595 47.9368H95.9403Z",
    fill: "#4669FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2691 93.2655C71.2771 90.5962 78.4351 85.853 84.0145 79.5187C89.594 73.1844 93.3957 65.485 95.0329 57.2041C96.6701 48.9232 96.0844 40.3564 93.3352 32.3754C90.586 24.3945 85.7716 17.2843 79.3819 11.7684L48.1595 47.9368L63.2691 93.2655Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47502 75.9816C15.5231 84.3242 24.1062 90.4881 33.9439 93.5538C43.7816 96.6195 54.3468 96.4228 64.0635 92.993L48.1595 47.9368L9.47502 75.9816Z",
    fill: "#B9FF4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7392 1.79871C27.6936 3.96455 20.3543 8.1966 14.4495 14.0749C8.5447 19.9532 4.27967 27.2734 2.07765 35.3091C-0.12437 43.3447 -0.186826 51.8166 1.89648 59.8838C3.97978 67.9511 8.13642 75.3334 13.9539 81.2981L48.1595 47.9368L35.7392 1.79871Z",
    fill: "#1CCD58"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1675,
    cy: 47.9376,
    rx: 32.4909,
    ry: 32.4909,
    fill: "#EEEEEE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.3def29f95cd328234c9251c879a7f719.svg";
export { ForwardRef as ReactComponent };